
import {
  GET_PROPS_LIST,
  UPDATE_LOADING_STATUS,
  UPDATE_DATA_TYPE
} from "../actions/featuresDetail";

const defVal = {
  propsList: [],
  dataType:"num",
  loading: true,
  totalProps: 0,
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_PROPS_LIST:
      return Object.assign({}, state, {
        propsList: action.propsList,
        totalProps: action.total
      });
    case UPDATE_LOADING_STATUS:
      return Object.assign({}, state, {
        loading: action.loading
      });
    case UPDATE_DATA_TYPE:
      return Object.assign({}, state, {
        dataType:action.dataType
      });
    default:
      return state;
  }
};
